module.exports = {
    GOGA_RANKING_SEASON_TIME_CONFIG: {
        key: 'GOGA_RANKING_SEASON_TIME',
        default_data: [
        ]
    },

    MODULE_CATEGORY: 'goga_rank',
}
